module.exports = __webpack_public_path__ + "static/img/2.0ca33e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/2.png
// module id = 2A/H
// module chunks = 0